
import MeetingSummery from "./component/MeetingSummery";

const MeetingSummeryView = () => {

   
    return (
        <>
            <MeetingSummery />
            {/* < ToastContainer /> */}
        </>
    )
}

export default MeetingSummeryView